import { computed, toValue } from "vue";
export const useSeoMatic = (refSeo) => {
  return computed(() => {
    const seo = toValue(refSeo);
    const metaData = {};
    let metaTag = {};
    let metaTitle = {};
    if (!seo || typeof seo === "undefined") {
      return {};
    }
    if (seo.metaTitleContainer && typeof seo.metaTitleContainer !== "undefined") {
      metaTitle = JSON.parse(seo.metaTitleContainer);
    }
    if (seo.metaTagContainer && typeof seo.metaTagContainer !== "undefined") {
      metaTag = JSON.parse(seo.metaTagContainer);
    }
    if (seo.metaLinkContainer && typeof seo.metaLinkContainer !== "undefined") {
      metaData.link = getLinksFields(JSON.parse(seo.metaLinkContainer));
    }
    if (metaTitle?.title?.title?.length) {
      metaData.title = metaTitle.title.title;
    }
    metaData.meta = [
      getDescription(metaTag),
      ...getMetaFields(metaTag, "og:"),
      ...getMetaFields(metaTag, "twitter:"),
      getRobots(metaTag)
    ];
    return metaData;
  });
};
const getLinksFields = (metaLink) => {
  const links = [];
  if (!metaLink) {
    return links;
  }
  if (metaLink?.canonical?.href?.length) {
    links.push(metaLink.canonical);
  }
  if (metaLink.home) {
    links.push(metaLink.home);
  }
  if (metaLink.author) {
    links.push(metaLink.author);
  }
  if (metaLink.publisher?.length) {
    links.push(...metaLink.publisher);
  }
  if (metaLink.alternate?.length) {
    links.push(...metaLink.alternate);
  }
  return links.filter(({ href }) => href);
};
const getDescription = (metaTag) => {
  if (metaTag?.description?.content?.length) {
    return { hid: "description", ...metaTag.description };
  }
  return {};
};
const getMetaFields = (metaTag, prefix) => {
  if (!metaTag) {
    return [];
  }
  return Object.keys(metaTag).filter((key) => key.indexOf(prefix) === 0).map((key) => {
    return { hid: key, name: key, content: metaTag?.[key]?.content };
  }).filter(({ content }) => content?.length);
};
const getRobots = (metaTag) => {
  if (metaTag?.robots) {
    return { hid: "robots", ...metaTag?.robots };
  }
  return {};
};
